/**
 * Chaque objet est un lien unissant deux membres
 * superclass de Blocage et MembreContact
 */
export class MembreRelation {
    /**
     * Constructeur de l'objet Blocage
     * @param contact contient les données de l'objet
     */
    constructor(relation) {
        if (relation) {
            const { idRelation, idExpediteur, idRecepteur } = relation;
            this.idRelation = idRelation;
            this.idExpediteur = idExpediteur;
            this.idRecepteur = idRecepteur;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlUmVsYXRpb24uY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJNZW1icmVSZWxhdGlvbi5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7O0dBR0c7QUFDSCxNQUFNLE9BQU8sY0FBYztJQWdCMUI7OztPQUdHO0lBQ0gsWUFBbUIsUUFBa0M7UUFDcEQsSUFBSSxRQUFRLEVBQUU7WUFDYixNQUFNLEVBQUUsVUFBVSxFQUFFLFlBQVksRUFBRSxXQUFXLEVBQUUsR0FBRyxRQUFRLENBQUM7WUFFM0QsSUFBSSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUM7WUFDN0IsSUFBSSxDQUFDLFlBQVksR0FBRyxZQUFZLENBQUM7WUFDakMsSUFBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7U0FDL0I7SUFDRixDQUFDO0NBQ0QifQ==